module.exports = __webpack_public_path__ + "img/banner-de.9b442766.png";